@if (!loading) {
  <div>
    @if (captures.length > 0) {
      <table class="table table-light m-0">
        <thead>
          <tr>
            <th>CLAIM ID</th>
            <th>STATUS</th>
            <th>OUTCOME</th>
            <th>SOURCE</th>
            <th>AKA</th>
            <th class="text-end">RX #</th>
            <th>STORE ID</th>
            @if (showEstimatedValue) {
              <th class="text-end">EST. VALUE</th>
            }
            <th class="text-end">SERVICE DATE &#x25BC;</th>
          </tr>
        </thead>
        <tbody>
          @for (capture of captures; track capture) {
            <tr>
              <td class="text-nowrap">
                @if (capture.id !== activeCaptureId) {
                  <div class="text-nowrap">
                    <a routerLink="{{ baseCaptureUrl + capture.id}}" target="_blank">{{ capture.candidate.claimIdentifier }}</a>
                  </div>
                } @else {
                  <div class="text-nowrap">{{ capture.candidate.claimIdentifier }}</div>
                  <strong class="text-nowrap"><em>this capture</em></strong>
                }
              </td>
              <td>{{ capture.status | captureStatus }}</td>
              <td>{{ capture.statusReason | captureStatusReason }}</td>
              <td>{{ capture.candidate.source }}</td>
              <td>{{ capture.candidate.ndcAkas.join(', ') }}</td>
              <td class="text-end ">
                <app-candidate-reference-number [candidate]="capture.candidate" />
              </td>
              <td>{{ capture.candidate.storeIdentifier }}</td>
              @if (showEstimatedValue) {
                <td class="text-end">{{ capture.candidate.estimatedValueForDisplay }}</td>
              }
              <td class="text-end">{{ capture.candidate.serviceDate | date: 'MM/dd/yyyy' }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p>There are no captures for this prescription.</p>
    }
  </div>
} @else {
  <div><mat-spinner diameter="30" /></div>
}
